module.exports = __webpack_public_path__ + "img/Bitmap-Copy-2.69619649.png";